/**
 * Admin Routes Configuration
 * 
 * This file centralizes all admin route paths to ensure consistency
 * and enable easy URL obfuscation for security.
 * 
 * The admin path is generated from an environment variable or uses a default
 * secure random string. This prevents easy discovery of the admin panel.
 */

// Generate a secure admin path from environment variable or use a default
// Format: /admin-{random-string}
// This makes it harder for attackers to find the admin panel
const ADMIN_PATH_SEGMENT = import.meta.env.VITE_ADMIN_PATH || 'admin-a7b3c9d2f1e4';

export const ADMIN_ROUTES = {
  BASE: `/${ADMIN_PATH_SEGMENT}`,
  LOGIN: `/${ADMIN_PATH_SEGMENT}/login`,
  BOOKINGS: `/${ADMIN_PATH_SEGMENT}/bookings`,
  SERVICES: `/${ADMIN_PATH_SEGMENT}/services`,
  CONTRACTORS: `/${ADMIN_PATH_SEGMENT}/contractors`,
  STATUS: `/${ADMIN_PATH_SEGMENT}/status`,
  SETTINGS: `/${ADMIN_PATH_SEGMENT}/settings`,
  PROMO_CODES: `/${ADMIN_PATH_SEGMENT}/promo-codes`,
} as const;

/**
 * Get the admin base path
 */
export function getAdminBasePath(): string {
  return ADMIN_ROUTES.BASE;
}

/**
 * Get the admin login path
 */
export function getAdminLoginPath(): string {
  return ADMIN_ROUTES.LOGIN;
}

/**
 * Check if a path is an admin path
 */
export function isAdminPath(path: string): boolean {
  return path.startsWith(ADMIN_ROUTES.BASE);
}

